import React, { useEffect } from "react";
import axiosInstance from "../axios/login";
import cookie from "react-cookies"
// import { useHistory } from "react-router-dom";

export default function SignUp() {
  // const history = useHistory();

  useEffect(() => {
    const response = axiosInstance.post("auth/revoke-token/", {
      client_id: "IwXZxqdvz8puzBpu1hX5mNJlQY38hDNK8tzhu6KL",
      token: cookie.load("refresh_token"),
      client_secret: "Bl83aJmhAK91vmdbPtfRF0xUVPQB2Y9rrwPzYePOgYm3qbX2Rs6GF8PV3GPOGbS1p5uVVKC9YAuysagrNsMSu2wNJWALxxTc8C0HKD4rOK4vX3ajhNNNOkP9R1hmn5Ku",
    });
    cookie.remove("access_token");
    cookie.remove("refresh_token");
    axiosInstance.defaults.headers["Authorization"] = null;
    // history.push("/login");
  });
  return <div>Logout</div>;
}
